module.exports = __webpack_public_path__ + "console/img/home2.e4745394.svg";